import { createContext, PropsWithChildren } from "react";
import { GetSiteResponse } from "~/api/endpoints/Site";
import { RoundingMethod, TaxAggMethod } from "~/entities/siteEntities";
import { CardSavingType, SavedCardPaymentFlow } from "~/entities/baseEntities";

const SiteContext = createContext<GetSiteResponse>({
  site: {
    id: "",
    siteName: "",
    siteImage: null,
    branding: null,
    siteAddress: {
      address1: "",
      address2: "",
      city: "",
      countryId: null,
      postalCode: "",
      state: "",
      latitude: null,
      longitude: null,
    },
    paymentMethods: [],
    uplistaGroupId: "",
    tableOrderingAllowPayAtTable: false,
    availability: [],
    serviceAvailability: [],
    orderTypes: [],
    activeTables: [],
    taxAggregationMethod: TaxAggMethod.PER_TAX,
    taxRoundingMethod: RoundingMethod.HALF_UP,
    pricesIncludeTax: true,
    countryCode: "NZ",
    onBehalfOf: "",
    timeZone: "",
    serviceSettings: [],
    openingTimes: [],
  },
  stripePublicKey: "",
  orgId: "",
  orgName: "",
  domainSettings: null,
  orgSettings: {
    paymentSettings: {
      savedCardPaymentFlow: SavedCardPaymentFlow._NOT_SET,
      cardSavingType: CardSavingType._NOT_SET,
    },
    giftCardSettings: {
      expirationDays: null,
    },
    customerSignInOptions: {
      passwordless: {
        email: false,
        sms: false,
      },
      signInWith: {
        google: false,
        apple: false,
      },
      smsAllowedCountryCodes: [],
    },
  },
});

export const SiteContextProvider = ({
  children,
  siteData,
}: PropsWithChildren<{ siteData: GetSiteResponse }>) => {
  return (
    <SiteContext.Provider value={siteData}>{children}</SiteContext.Provider>
  );
};

export default SiteContext;
